import { render, staticRenderFns } from "./newtov.vue?vue&type=template&id=4c19cb4f&"
import script from "./newtov.vue?vue&type=script&lang=js&"
export * from "./newtov.vue?vue&type=script&lang=js&"
import style0 from "./newtov.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports